// @ts-strict-ignore
import styled from "styled-components";
import { Body } from "components/parts/Typography";

const Flex = styled.div`
  display: flex;
`;

// Hides the ticker bar under the footer on the homepage
export const HoverContainer = styled.div`
  position: relative;
  height: auto !important;
  z-index: 100 !important;
  ${({ theme }) =>
    !theme.isDark && `background-color: ${theme.backgroundColors.secondary};`}
`;

export const GroupListTop = styled.div`
  flex-direction: column;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  ${({ theme: { media } }) => media.tablet`
    flex-direction: column;
  `}
`;

export const CopyrightInfoDesktop = styled(Flex)`
  width: 100%;
  max-width: 1200px;
  flex-direction: column;
  margin: 1rem auto 2rem;
` as typeof Flex;

export const CopyrightInfoMobile = styled(Flex)`
  width: 100%;
  max-width: 1200px;
  flex-direction: column;
  margin: -1rem auto 0rem;
  align-items: center;
  padding-bottom: 1rem;
` as typeof Flex;

export const FooterLinksBlock = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const FooterItem = styled(Body).attrs({ size: "sm", as: "li" })<{
  type: string;
}>`
  list-style: none;
  height: 20px;
  margin-bottom: ${({ type }) =>
    type === "subheading" || type === "subsectionHeading" ? "16px" : "8px"};
  margin-top: ${({ type }) => (type === "subsectionHeading" ? "38px" : "0px")};
  font-weight: ${({ theme, type }) =>
    type === "subheading" || type === "subsectionHeading"
      ? theme.fontWeight.bold
      : theme.fontWeight.semiBold};
`;

export const Line = styled.div<{ isDark?: boolean }>`
  height: 1px;
  width: 100%;
  margin: 0;
  border-bottom: 1px solid
    ${({ theme, isDark = false }) =>
      isDark ? theme.textColors.primary : theme.borderColors.primary};
  /*${({ theme: { media } }) => media.tablet`
    width: 692px;
    padding-left: 32px;
    padding-right: 32px;
    margin: 0 0 24px 0;
  `}*/
  ${({ theme: { media } }) => media.desktop`
    display:none;
    width: 100%;
    padding:0;
  `}
`;

export const ListItem = styled.li<{ type: string }>`
  list-style: none;
  margin-top: ${({ type }) => (type === "subsectionHeading" ? "25px" : "0px")};
`;
export const StyledCopyrightContainer = styled(Flex)`
  width: 100%;
  max-width: 1200px;
  flex-direction: column;
  align-items: center;

  ${({ theme: { media } }) => media.desktop`
    align-items: flex-start;
  `}
`;

export const FooterRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${({ theme: { media } }) => media.desktop`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `}
`;

export const FooterText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;

  ${({ theme: { media } }) => media.desktop`
    text-align: left;
  `}
`;

export const DesktopOnly = styled.div`
  display: none;

  ${({ theme: { media } }) => media.desktop`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2rem;
  `}
`;

export const RecaptchaWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 1rem;

  ${({ theme: { media } }) => media.desktop`
    justify-content: space-between;
    align-items: center;
    margin-top: 0;
  `}
`;

export const MobileOnly = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;

  ${({ theme: { media } }) => media.desktop`
    display: none;
  `}
`;

export const MobileDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.borderColors.primary};
  margin: 1rem 0;
`;

export const LegalLinksWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  ${({ theme: { media } }) => media.desktop`
    gap: 2rem;
  `}
`;
